/* eslint-disable */
export default (key, message) =>
  crypto.subtle.sign({ name: 'RSA-PSS', saltLength: 32 }, key, message);
